import dayjs from "dayjs";
import { defaultDateFormat } from "src/shared/components/fields/DatePicker";
import {
  IPartnerComplexContractFormValues,
  IPartnerComplexContractItem,
  IPartnerVirtualContractFormValues,
  IPartnerVirtualContractItem,
} from "../types";

export const getPartnerComplexContractFormValues = (
  contract: IPartnerComplexContractItem,
): IPartnerComplexContractFormValues => {
  return {
    id: contract.id,
    partner_id: contract.partner_id,
    site: contract.site,
    contract_email: contract.contract_email,
    contract_state: contract.contract_state.value,
    partner_bonus_min_sum: Number(contract.partner_bonus_min_sum),
    contract_number: contract.contract_number,
    contract_date: dayjs(contract.contract_date),
    currency: contract.currency.value,
    tax_value: contract.tax_value,
    tax_system: contract.tax_system.value,
    original_availability: contract.original_availability.value,
    contract_manager: contract.contract_manager?.id || "",
    context_teamlead: contract.context_teamlead?.id || "",
    account_manager: contract.account_manager?.id || "",
    note: contract.note,
    has_tax_certificate: contract.has_tax_certificate,
    tax_certificate_path: contract.tax_certificate_path,
    tax_certificate_attach_date: contract.tax_certificate_attach_date,
    contract_original_file_path: contract.contract_original_file_path,
    contract_original_attach_date: contract.contract_original_attach_date,
    edit_notes: contract.edit_notes,
    with_edits: contract.with_edits,
    customer_info: {
      represented_by: contract.customer_info.represented_by,
      signs: contract.customer_info.signs || "",
      bases_on: contract.customer_info.bases_on || "",
      position: contract.customer_info.position || "",
    },
    executor_info: {
      represented_by: contract.executor_info.represented_by || "",
      bases_on: contract.executor_info.bases_on || "",
      position: contract.executor_info.position || "",
      signs: contract.executor_info.signs || "",
    },
  };
};

export const getPartnerVirtualContractFormValues = (
  virtualContract: IPartnerVirtualContractItem,
): IPartnerVirtualContractFormValues => ({
  ...virtualContract,
  contract_number: virtualContract.contract_number || "",
  partner_contract_id: virtualContract.partner_contract_id || "",
  service_name: virtualContract.service_name.value,
  service_currency: virtualContract.service_currency.value,
  state: virtualContract.state.value,
  contract_date: dayjs(virtualContract.contract_date),
});

export const getAgreementModalTitle = ({
  contract_number,
  partner_name,
}: {
  partner_name: string;
  contract_number: string;
}) => `Соглашение к договору № ${contract_number} (${partner_name})`;

export const getAgreementModalText = ({
  contract_date,
  contract_number,
}: Pick<IPartnerComplexContractItem, "contract_number" | "contract_date">) =>
  `ДОПОЛНИТЕЛЬНОЕ СОГЛАШЕНИЕ к договору № ${contract_number} от ${dayjs(
    contract_date,
  ).format(defaultDateFormat)}`;
